import { buildUrl, handleResponse } from "./auth";

const buildQuery = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    );
  return parts.length ? `?${parts.join("&")}` : "";
};

export const getAdminCustomers = (params) =>
  fetch(buildUrl(`/api/admin/customers${buildQuery(params)}`), {
    credentials: "include",
  }).then(handleResponse);

export const blockAdminCustomer = (payload) =>
  fetch(buildUrl("/api/admin/customers/block"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    credentials: "include",
  }).then(handleResponse);

export const unblockAdminCustomer = (email) =>
  fetch(buildUrl(`/api/admin/customers/block?email=${encodeURIComponent(email)}`), {
    method: "DELETE",
    credentials: "include",
  }).then(handleResponse);

const adminCustomersApi = {
  getAdminCustomers,
  blockAdminCustomer,
  unblockAdminCustomer,
};

export default adminCustomersApi;
